module.exports = __webpack_public_path__ + "static/detecht-extraimg3-d2e78970e99f9d01cf331c64aef8d08f.png";